var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserValue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 105.029C0 118.836 11.1929 130.029 25 130.029H105.029C118.836 130.029 130.029 118.836 130.029 105.029V25C130.029 11.1929 118.836 0 105.029 0H25C11.1929 0 0 11.1929 0 25V105.029ZM79 47.9901C79 55.7221 72.732 61.9901 65 61.9901C57.268 61.9901 51 55.7221 51 47.9901C51 40.2581 57.268 33.9901 65 33.9901C72.732 33.9901 79 40.2581 79 47.9901ZM37.5927 87.1599C35.8379 92.3965 40.4772 96.9901 46 96.9901H84C89.5229 96.9901 94.1621 92.3965 92.4073 87.1599C88.4729 75.4194 77.688 66.9901 65 66.9901C52.312 66.9901 41.5271 75.4194 37.5927 87.1599Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 105.029C0 118.836 11.1929 130.029 25 130.029H105.029C118.836 130.029 130.029 118.836 130.029 105.029V25C130.029 11.1929 118.836 0 105.029 0H25C11.1929 0 0 11.1929 0 25V105.029ZM79 47.9901C79 55.7221 72.732 61.9901 65 61.9901C57.268 61.9901 51 55.7221 51 47.9901C51 40.2581 57.268 33.9901 65 33.9901C72.732 33.9901 79 40.2581 79 47.9901ZM37.5927 87.1599C35.8379 92.3965 40.4772 96.9901 46 96.9901H84C89.5229 96.9901 94.1621 92.3965 92.4073 87.1599C88.4729 75.4194 77.688 66.9901 65 66.9901C52.312 66.9901 41.5271 75.4194 37.5927 87.1599Z",
    fill: "url(#paint0_linear_108_5635)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_108_5635",
    x1: 65.0146,
    y1: 130.031,
    x2: 65.0146,
    y2: 0.00209259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserValue);
export default __webpack_public_path__ + "static/media/userValue.bb1215165edd15d56c78fc0a99308cea.svg";
export { ForwardRef as ReactComponent };